<template>
    <div class="overflow-hidden p-5 lg:h-screen">
        <div class="grid gap-5 md:grid-cols-1 lg:h-full lg:grid-cols-2">
            <v-ip-card class="lg:col-span-2" />

            <v-char-card />

            <v-word-card />

            <v-phrase-card />

            <v-hash-card />
        </div>
    </div>
</template>

<script setup lang="ts">
useServerSeoMeta({
    title: 'Password generator',
});
</script>
